/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Player_Audio_Track_LabelInputs */

const en_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.index}`)
};

const fr_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piste ${i?.index}`)
};

const de_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.index}`)
};

const it_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traccia ${i?.index}`)
};

const ru_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Трек ${i?.index}`)
};

const es_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pista ${i?.index}`)
};

const zh_cn2_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追踪${i?.index}`)
};

const ja_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.index}`)
};

const hi_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.index}`)
};

const pt_pt2_player_audio_track_label = /** @type {(inputs: Player_Audio_Track_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faixa ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Track {index}" |
*
* @param {Player_Audio_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_audio_track_label = /** @type {((inputs: Player_Audio_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Audio_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_audio_track_label(inputs)
	if (locale === "de") return de_player_audio_track_label(inputs)
	if (locale === "it") return it_player_audio_track_label(inputs)
	if (locale === "ru") return ru_player_audio_track_label(inputs)
	if (locale === "es") return es_player_audio_track_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_audio_track_label(inputs)
	if (locale === "ja") return ja_player_audio_track_label(inputs)
	if (locale === "hi") return hi_player_audio_track_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_audio_track_label(inputs)
	return en_player_audio_track_label(inputs)
});